<nb-card>
  <nb-card-header>
    <div>
      <button
        [ngClass]="menu == 'info' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'info' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltip="Thông tin"
        nbTooltipPlacement="bottom"
        (click)="selectMenu('info')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        <span>Thông tin</span>
      </button>

      <button
        [ngClass]="menu == 'content' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'content' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltip="Nội dung"
        nbTooltipPlacement="bottom"
        (click)="selectMenu('content')"
      >
        <nb-icon class="button-icon" icon="file-text-outline"></nb-icon>
        <span>Nội dung</span>
      </button>
    </div>

    <div *ngIf="lecture.refTitle" class="text-link">
      <nb-icon icon="globe-outline"></nb-icon>
      <a class="link" (click)="navigateRef(lecture)">
        {{
          lecture.refTitle.length < 60
            ? lecture.refTitle
            : lecture.refTitle.substring(0, 60) + "..."
        }}
      </a>
    </div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <form *ngIf="menu == 'info'" [formGroup]="diaForm">
      <div class="form-group">
        <div class="label">
          <h6 class="text-primary">Tiêu đề</h6>
          <p class="text-hint">Ngắn gọn, rõ ràng nêu lên chủ đề cần chia sẻ</p>
        </div>
        <input
          type="text"
          nbInput
          fullWidth
          formControlName="title"
          placeholder="Nhập tiêu đề"
          class="form-control"
          [(ngModel)]="lecture.title"
        />
      </div>

      <div class="form-group">
        <div class="label">
          <h6 class="text-primary">Mô tả</h6>
          <p class="text-hint">
            Tóm tắt nội dung ngắn gọn, giúp người đọc có thể nắm nhanh được bài
            viết
          </p>
        </div>
        <textarea
          nbInput
          fullWidth
          id="inputDescription"
          placeholder="Nhập mô tả"
          class="form-control"
          formControlName="description"
          [(ngModel)]="lecture.description"
        ></textarea>
      </div>
    </form>

    <div *ngIf="menu == 'info'" class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label class="label">
            Hình đại diện
            <button
              nbButton
              ghost
              size="none"
              status="danger"
              [disabled]="submitted"
              [class.btn-pulse]="submitted"
              (click)="removeCoverUrl()"
            >
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </label>
          <ngx-upload-image
            [size]="'tiny'"
            [mode]="'imagekit'"
            [path]="'/lecture/cover'"
            [imageURL]="imageURL"
            (onUploadSuccess)="updateImage($event)"
          ></ngx-upload-image>
        </div>
      </div>

      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label class="label">Nhập phân loại ( Tag)</label>
          <nb-tag-list (tagRemove)="onTagRemove($event)">
            <nb-tag *ngFor="let tree of trees" [text]="tree" removable></nb-tag>
            <input
              type="text"
              nbTagInput
              (tagAdd)="onTagAdd($event)"
              fullWidth
            />
          </nb-tag-list>
        </div>

        <div *ngIf="user.admin || user.moderator" class="form-group">
          <label class="label">Chia sẻ</label>
          <nb-radio-group [(ngModel)]="lecture.privacy">
            <nb-radio [checked]="lecture.privacy" [value]="true"
              >Khóa học</nb-radio
            >
            <nb-radio [checked]="!lecture.privacy" [value]="false"
              >Cộng đồng</nb-radio
            >
          </nb-radio-group>
        </div>

        <div *ngIf="user.admin || user.moderator" class="form-group">
          <nb-checkbox [(ngModel)]="lecture.newComment" status="warning"
            >Bình luận mới</nb-checkbox
          >
          <nb-checkbox [(ngModel)]="lecture.showComments" status="info"
            >Xem bình luận</nb-checkbox
          >
        </div>
      </div>
    </div>

    <div *ngIf="menu == 'content'" class="form-group">
      <div class="label">
        <h6 class="text-primary">
          Nội dung chi tiết
          <nb-select
            outline
            shape="round"
            size="small"
            status="info"
            [(ngModel)]="lecture.sourceType"
          >
            <nb-option value="document">Tài liệu</nb-option>
            <nb-option value="video">Video</nb-option>
            <nb-option value="images">Hình ảnh</nb-option>
          </nb-select>
        </h6>
      </div>

      <div *ngIf="lecture.sourceType == 'video'" class="form-group">
        <ngx-view-video [url]="lecture.videoUrl"></ngx-view-video>
        <div class="form-group">
          <label class="label">Đường dẫn URL</label>
          <input
            nbInput
            fullWidth
            placeholder="Nhập liên kết"
            class="form-control"
            [(ngModel)]="lecture.videoUrl"
          />
        </div>
      </div>

      <div *ngIf="lecture.sourceType == 'images'">
        <nb-card>
          <nb-card-header>
            <button
              nbButton
              outline
              fullWidth
              status="info"
              size="tiny"
              [disabled]="submitted"
              [class.btn-pulse]="submitted"
              (click)="openGallery()"
            >
              <nb-icon icon="image-outline"></nb-icon>
              Chọn hình ảnh
            </button>
          </nb-card-header>
          <nb-card-body class="container">
            <div class="row">
              <div class="column" *ngFor="let item of imagesUrl; let i = index">
                <button
                  nbButton
                  outline
                  fullWidth
                  status="danger"
                  size="tiny"
                  [disabled]="submitted"
                  [class.btn-pulse]="submitted"
                  (click)="deleteImage(item)"
                >
                  <nb-icon icon="trash-2-outline"></nb-icon>
                </button>
                <img [src]="item" style="width: 100%" />
              </div>
            </div>
          </nb-card-body>
        </nb-card>
      </div>

      <ngx-editor-document
        *ngIf="lecture.sourceType == 'document'"
        [(ngModel)]="lecture.content"
      ></ngx-editor-document>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <nb-select
      hero
      size="small"
      [status]="status == '1' ? 'success' : status == '0' ? 'info' : 'warning'"
      placeholder="Chọn trạng thái"
      [(ngModel)]="status"
    >
      <nb-option value="1">Xuất bản</nb-option>
      <nb-option value="0">Đang thực hiện</nb-option>
      <nb-option value="-1">Ẩn nội dung</nb-option>
    </nb-select>
    <button
      type="submit"
      nbButton
      status="primary"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      Lưu
    </button>
  </nb-card-footer>
</nb-card>
